<template>
  <div class="default-page default-page-center status-page">
    <p class="status-page-code">404</p>
    <p class="mb-5">Мы не смогли найти нужную страницу</p>
    <button @click="gotoHome" class="btn btn-primary btn-lg btn-min-width rounded-pill">На главную</button>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

function gotoHome() {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.status-page {
  text-align: center;

  &-code {
    font-size: 100px;
  }
}
</style>